import * as React from "react";
import useCurrentUser from "hooks/useCurrentUser";
import isActiveRoute from "components/navigation/util/isActiveRoute";
import { isPermitted } from "util/PermissionsMixin";
import { NavDropdown } from "components/bootstrap";
import NavigationLink from "components/navigation/NavigationLink";
import AppConfig from "util/AppConfig";
const shouldRender = (requiredFeatureFlag, requiredPermissions, userPermissions) => {
  if (requiredFeatureFlag) {
    return AppConfig.isFeatureEnabled(requiredFeatureFlag);
  }
  if (requiredPermissions) {
    return isPermitted(userPermissions, requiredPermissions);
  }
  return true;
};
const renderLinkTitle = (description, Badge) => Badge ? /* @__PURE__ */ React.createElement(Badge, { text: description }) : description;
const PluginNavDropdown = ({ menuItems, description, BadgeComponent, pathname }) => {
  const currentUser = useCurrentUser();
  const activeMenuItem = menuItems.filter(({ path, end }) => path && isActiveRoute(pathname, path, end));
  const title = activeMenuItem.length > 0 ? `${description} / ${activeMenuItem[0].description}` : description;
  const accessibleMenuItems = menuItems.filter(
    ({ requiredFeatureFlag, permissions }) => shouldRender(requiredFeatureFlag, permissions, currentUser.permissions)
  );
  if (!accessibleMenuItems.length) {
    return null;
  }
  const renderBadge = menuItems.some((menuItem) => menuItem == null ? void 0 : menuItem.BadgeComponent);
  return /* @__PURE__ */ React.createElement(NavDropdown, { key: title, title, Badge: renderBadge ? BadgeComponent : void 0, inactiveTitle: description }, accessibleMenuItems.map((menuItem) => /* @__PURE__ */ React.createElement(
    NavigationLink,
    {
      key: menuItem.description,
      Badge: menuItem.BadgeComponent,
      description: menuItem.description,
      path: menuItem.path
    }
  )));
};
const NavigationItem = ({
  navigationItem: { requiredFeatureFlag, permissions, children, BadgeComponent, description, path },
  pathname
}) => {
  const currentUser = useCurrentUser();
  if (!shouldRender(requiredFeatureFlag, permissions, currentUser.permissions)) {
    return null;
  }
  if (children) {
    return /* @__PURE__ */ React.createElement(
      PluginNavDropdown,
      {
        menuItems: children,
        description,
        BadgeComponent,
        pathname,
        key: description
      }
    );
  }
  return /* @__PURE__ */ React.createElement(NavigationLink, { key: description, description: renderLinkTitle(description, BadgeComponent), path, topLevel: true });
};
export default NavigationItem;
